import React from "react";

export default class Timer extends React.Component {
  state = {
    time: {},
    countDown: null,
  };
  handleCountDown = (seconds) => {
    var secs = seconds;
    const countDown = setInterval(() => {
      const date = new Date(secs * 1000);
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      const day = (secs / 86400).toString().split(".")[0];
      if (secs > 0) {
        secs--;
        this.setState({ time: { day, hour, minute, second } });
      } else {
        clearInterval(countDown);
      }
    }, 1000);
    this.setState({ timer: countDown });
  };
  componentDidMount() {
    this.handleCountDown(this.props.expireTime);
  }
  componentWillUnmount() {
    clearInterval(this.state.countDown);
  }

  render() {
    return (
      <div className={"clubTimer"}>
        <div className={"timer"}>
          <div className={"time"}>
            {String(this.state.time?.second).length == 2 ? (
              <span className={"value"}>
                {String(this.state.time?.second).slice(0, 1)}

                {String(this.state.time?.second).slice(1, 2)}
              </span>
            ) : (
              <>
                <span className={"value"}>
                  0{String(this.state.time?.second).slice(0, 1)}
                </span>
              </>
            )}
          </div>
          <span className={"timerTitle"}>ثانیه</span>
        </div>
        <div className={"timer"}>
          <div className={"time"}>
            {String(this.state.time?.minute).length == 2 ? (
              <>
                <span className={"value"}>
                  {String(this.state.time?.minute).slice(0, 1)}

                  {String(this.state.time?.minute).slice(1, 2)}
                </span>
              </>
            ) : (
              <>
                <span className={"value"}>
                  0{String(this.state.time?.minute).slice(0, 1)}
                </span>
              </>
            )}
          </div>
          <span className={"timerTitle"}>دقیقه</span>
        </div>
        <div className={"timer"}>
          <div className={"time"}>
            {String(this.state.time?.hour).length == 2 ? (
              <>
                <span className={"value"}>
                  {String(this.state.time?.hour).slice(0, 1)}

                  {String(this.state.time?.hour).slice(1, 2)}
                </span>
              </>
            ) : (
              <>
                <span className={"value"}>
                  0{String(this.state.time?.hour).slice(0, 1)}
                </span>
              </>
            )}
          </div>
          <span className={"timerTitle"}>ساعت</span>
        </div>
        <div className={"timer"}>
          <div className={"time"}>
            {String(this.state.time?.day).length == 2 ? (
              <>
                <span className={"value"}>
                  {String(this.state.time?.day).slice(0, 1)}

                  {String(this.state.time?.day).slice(1, 2)}
                </span>
              </>
            ) : (
              <>
                <span className={"value"}>
                  0{String(this.state.time?.day).slice(0, 1)}
                </span>
              </>
            )}
          </div>
          <span className={"timerTitle"}>روز</span>
        </div>
      </div>
    );
  }
}
